import { CatalogTitle, LandingPageComponent, LandingPageJsonResponse } from "../landing-page.model";

export interface CatalogsViewModel {
  featuredCatalogs: CatalogTitle[];
  catalogTiles: CatalogTitle[];
}

export interface CatalogApiItem extends CatalogTitle {
  catalogTitle?: string;
  ctaTitle?: string;
  catalogDescription?: string;
  catalogPlacement?: "primary" | "secondary" | string;
}

export type CatalogsPageResponse = {
  data?: LandingPageJsonResponse;
} | LandingPageJsonResponse | null | undefined;

export function getCatalogComponents(response: CatalogsPageResponse): LandingPageComponent[] {
  if (!response) return [];
  if ("data" in response && response.data) return response.data.pageComponents ?? [];
  return "pageComponents" in response ? response.pageComponents ?? [] : [];
}
